module.exports = __webpack_public_path__ + "static/media/01-1.4fd8c3f9.webp";